import React, { useState } from "react";

import ConfirmPasswordInput from "../../input/TextField/ConfirmPasswordInput";
import { BASE_URL } from "../../../customHooks/config";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import Spinner from "../../layout/loader/Spinner";

function CreatePassword({ setStep }) {
  const [loading, setLoading] = useState(false);
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const handleChangePassword = () => {
    if (password1 === password2) {
      setLoading(true);
      axios
        .post(`${BASE_URL}vendor/reset_password/`, {
          uid: params.uid,
          token: params.token,
          password: password1,
        })
        .then((res) => {
          setLoading(false);
          if (res?.data?.success) {
            toast.success(res?.data?.data?.message);
            navigate("/");
          } else toast.error(res?.data?.error);
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err?.data?.error);
        });
    } else toast.error("Passwords doesn't match with each other");
  };

  return (
    <div className="w-8/12 mt-10">
      <div className=" mt-5">
        <ConfirmPasswordInput
          label="Create new password"
          setPassword={setPassword1}
        />
        <ConfirmPasswordInput
          label="Re-Type new password"
          setPassword={setPassword2}
        />
      </div>
      <div className=" mt-5">
        <button className="btn-primary" onClick={handleChangePassword}>
          {loading ? <Spinner /> : "Change Password"}
        </button>
      </div>
      <div className=" mt-5">
        <p
          className="text-xs text-[#64748B] text-center"
          style={{ fontFamily: "gilRoy-semibold" }}
        >
          Any tech related issues?{" "}
          <a
            href="mailto:support@getwork.org"
            className="text-[#2563EB] cursor-pointer "
          >
            {" "}
            Connect with us{" "}
          </a>
        </p>
      </div>
    </div>
  );
}

export default CreatePassword;
